import $ from 'jquery';

$(document).on('ready turbolinks:load', function () {
    $('.selectpicker').selectpicker();

    $('#clear_filters').on('click', function () {
        $("#resume_form input[type='text']").val('');
        $("#resume_form input[type='number']").val('');

        $('.selectpicker').val('').selectpicker('refresh');
    });
});
